import React from "react"
import { copyWrapper } from "@components/rich-text/richText.module.css"
import { isVisibleIn } from "@utils/region"
import RichText from "@components/rich-text"

const TextBlock = ({ copyText, visibilityRegions }) => {
  if (!isVisibleIn(visibilityRegions)) return <></>

  return <RichText paragraphClassName={copyWrapper} text={copyText} />
}

export default TextBlock
